import React, { Fragment } from 'react';
import { Button } from 'antd';
import MainLayout from '../layouts/MainLayout';
import { alertFail } from '../Alert';
import * as api from '../../api';

const Main = ({
  history,
}) => {
  const goBookingAuthPage = () => {
    const handleCreateToken = async () => {

      const queryParams = new URLSearchParams(window.location.search);
      const hotelCode = encodeURIComponent(queryParams.get('h') ?? '');

      if (!hotelCode) {
        alertFail('hotel_code를 찾을 수 없습니다. 웹 브라우저 종료 후 전달받으신 링크로 재진입해주세요.', 3);
      } else {
        const res = await api.getForestTripHotelInfo({
          encHotelCode: hotelCode
        });

        localStorage.setItem('params', JSON.stringify({ hotel_id: res.data.hotel_id }));
        history.push('/booking/auth');
      }
    };

    handleCreateToken();
  };

  return (
    <MainLayout
      history={history}
      ContentBody={(
        <Fragment>
          <div className='mt-30 ta-center pt-20'>
            <img className='content-main-logo' src='../../assets/images/content_main_logo.png' alt='main-logo'/>
          </div>
          <p className='mt-30 ta-center fs-18 bold c-white'>자연휴양림 스마트 체크인 키발급 서비스</p>
          <p className='ta-center m-10 fs-16 c-white'>키발급 서비스를 이용하기 위해<br/>예약 조회를 해주세요.</p>
          <Button type='primary' size='large' className='mt-45 basic-button light-green' onClick={goBookingAuthPage}>예약 조회</Button>
        </Fragment>
      )}
    />
  );
};

export default Main;